export const ERROR_DIALOG = {
  NONE: 'NONE',
  FULLSCREEN: 'FULLSCREEN',
  MODAL: 'MODAL',
  SNICKERS: 'SNICKERS',
} as const;
